"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["BUSINESS_ERROR"] = "BUSINESS_ERROR";
    ErrorCode["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    ErrorCode["UNKNOWN_USER_OR_CODE"] = "UNKNOWN_USER_OR_CODE";
    ErrorCode["USER_DATA_ERROR"] = "USER_DATA_ERROR";
    ErrorCode["NOT_UNIQUE_EMAIL"] = "NOT_UNIQUE_EMAIL";
    ErrorCode["CALCULATION_ERROR"] = "CALCULATION_ERROR";
    ErrorCode["OBJECT_DATA_ERROR"] = "OBJECT_DATA_ERROR";
    ErrorCode["INVALID_ROLE"] = "INVALID_ROLE";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
